import { render, staticRenderFns } from "./seating.vue?vue&type=template&id=9788cb5a&"
import script from "./seating.vue?vue&type=script&lang=js&"
export * from "./seating.vue?vue&type=script&lang=js&"
import style0 from "./seating.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "seating.vue"
export default component.exports